import './lastMovements.css'
import React from "react";
import {dayMonthYearAtTimeWithSeconds} from "../../../utils/dates";
import EPCLink from "../../Asset/EPCLink";

function LatestMovements({data, location}) {

  const locationMap = () => {
    if (location.length > 0) {
      return location.map(y => {
        const match = data && data.some(x => x.asset.currentState.lsd.bizLocation.id === y.id);
        if (!match) {
          return (
            <article className="card-box">
              <div className="cards-header" style={{borderBottom:" none"}}>
                {y.friendlyName}
              </div>
              <div style={{justifyContent: "center", display: "flex"}}>
                <h2>Local sem produto</h2>
              </div>
            </article>
          )
        }
      })
    }
  }

  return (
    <div className="card-container">
      {data.length > 0 && data.map(x => (
        <article className="card-box">
          <div className="cards-header">
            {x.asset.currentState.lsd.bizLocation.friendlyName}
          </div>
          <div>
            <b>Nome: </b>{x.asset.productType.friendlyName}
          </div>
          <div>
            <b>Referência: </b>{x.asset.productType.reference}
          </div>
          <div>
            <b>Etapa: </b>{x.asset.currentState.lsd.bizStep.description}
          </div>
          <div>
            <b>Disposição: </b>{x.asset.currentState.lsd.disposition.description}
          </div>
          <div>
            <b>EPC: </b>{x.asset.tags.map(e => (
              <div>
                <EPCLink epc={e}/>
              </div>
            )
          )}
          </div>
          <div className="card-footer1">
            {dayMonthYearAtTimeWithSeconds(x.asset.currentState.stateDate)}
          </div>
        </article>
      ))
      }
      {locationMap()}
    </div>
  )
}

export default LatestMovements;



// WEBPACK FOOTER //
// ./src/component/Card/latestMovements/LatestMovements.js